import React, { Component } from "react";
import { Table } from "reactstrap";
import libraryService from "../../../services/contentLibraryService";
import connect from "react-redux/es/connect/connect";
import { ROLE_MPS_ADMIN } from "../../../security/roles";
import MPSButton from "../../../components/Buttons/Buttons/MPSButton";
import MPSBarLoader from "../../../components/MPSBarLoader";
import MPSSelect from "../../../components/MPSSelect";
import InfiniteScroller from "../../../components/InfiniteScroller";
import Messages from "../../Messages";
import I18nProvider from "../../../services/I18nProvider";
const intl = I18nProvider.getIntlProvider();

function createTopicsMap(topics) {
  let topicsMap = {};
  topics.forEach((topic) => {
    topicsMap[topic.topicId] = topic;
  });

  return topicsMap;
}

class ContentLibrarySelector extends Component {
  constructor(props) {
    super(props);
    this.state = { libraries: [], filter: {}, pageInfo: { number: -1 } };
  }

  componentDidMount() {
    let { userRole, libraries, topics, patientTypeId, libraryId } = this.props;
    if (userRole === ROLE_MPS_ADMIN) {
      this.setState({ libraries, topicsMap: createTopicsMap(topics) });
      return;
    }
    this.loadLibraries(0);
    libraryService.loadTopics(patientTypeId).then((tops) => {
      this.setState({
        topicsMap: createTopicsMap(tops),
        topics: tops,
        loading: false,
      });
    });
    if (libraryId) {
      libraryService.loadById(libraryId).then((lib) => {
        if (lib && !this.state.selectedItem) {
          this.setState({ selectedItem: lib });
        }
      }).catch(() => {});
    }
  }

  findSelectedItem = (libraries) => {
    let { libraryName, libraryId } = this.props;
    if (!libraryName && !libraryId) return null;
    return libraries.find(
      (item) =>
        item.name === libraryName ||
        item.id === libraryId ||
        (item.idFromPackage && item.idFromPackage === libraryId) ||
        (item.originalIDFromPackage && item.originalIDFromPackage === libraryId)
    ) || null;
  };

  loadLibraries = () => {
    let { onlyPublicContent, patientTypeId } = this.props;
    let filter = {
      ...this.state.filter,
      pTypeId: patientTypeId,
      onlyPublicContent,
    };
    this.setState({ loading: true });
    let { pageInfo } = this.state;

    libraryService
      .load(pageInfo.number + 1, filter)
      .then((response) => {
        const allLibraries = this.state.libraries.concat(response.list);
        const newState = {
          libraries: allLibraries,
          pageInfo: {
            number: response.number,
            totalPages: response.totalPages,
            loadMore: response.loadMore,
            totalItems: response.totalItems,
          },
          loading: false,
        };
        if (!this.state.selectedItem) {
          const found = this.findSelectedItem(allLibraries);
          if (found) {
            newState.selectedItem = found;
          }
        }
        this.setState(newState);
      })
      .catch((e) => {
        this.setState({ loading: false });
      });
  };

  handleFilterFieldChange = (name, value) => {
    let { filter = {} } = this.state;
    filter[name] = value;
    this.setState({ filter: { ...filter } });
  };

  onSearch = (e) => {
    e.preventDefault();
    e.stopPropagation();
    let { filter } = this.state;
    this.setState(
      { libraries: [], pageInfo: { number: -1 }, filter: { ...filter } },
      this.loadLibraries
    );
  };

  // handleTopicChange = topic => {
  //   let { patientTypeId, onlyPublicContent } = this.props;
  //   if (topic) {
  //     this.setState({ topic: topic.topicId });
  //     libraryService
  //       .load(0, patientTypeId, topic.topicId, onlyPublicContent)
  //       .then(libs => {
  //         this.setState({
  //           libraries: libs.list
  //         });
  //       });
  //   } else {
  //     this.setState({ topic: null });
  //     libraryService
  //       .load(null, patientTypeId, null, onlyPublicContent)
  //       .then(libs => {
  //         this.setState({
  //           libraries: libs.list
  //         });
  //       });
  //   }
  // };

  render() {
    let { libraryName, libraryId, userRole } = this.props;
    let { loading, libraries, topicsMap, topics, filter, pageInfo } =
      this.state;

    if (!topicsMap || !libraries) {
      return null;
    }

    return (
      <div>
        {userRole !== ROLE_MPS_ADMIN && (
          <div className="card my-2">
            <div className="card-body">
              <form
                className="d-flex justify-content-between"
                onSubmit={this.onSearch}
              >
                <div className="mr-2">
                  <input
                    className="form-control"
                    value={filter.searchTerm}
                    onChange={(e) =>
                      this.handleFilterFieldChange("searchTerm", e.target.value)
                    }
                    placeholder="Search"
                  />
                </div>
                <div style={{ width: 300 }}>
                  <MPSSelect
                    name="form-field-name"
                    placeholder={intl.formatMessage(Messages.filter_by_topic)}
                    value={filter.topicId}
                    onChange={(topic) => {
                      this.handleFilterFieldChange(
                        "topicId",
                        topic ? topic.topicId : null
                      );
                    }}
                    options={topics}
                    valueKey="topicId"
                    labelKey="title"
                  />
                </div>

                <MPSButton
                  type="submit"
                  color="primary"
                  size={"md"}
                  className="text-capitalize"
                >
                  Submit
                </MPSButton>
              </form>
            </div>
          </div>
        )}

        {(() => {
          const selItem = this.state.selectedItem || libraries.find(
            (item) =>
              item.name === libraryName ||
              item.id === libraryId ||
              (item.idFromPackage && item.idFromPackage === libraryId) ||
              (item.originalIDFromPackage && item.originalIDFromPackage === libraryId)
          );
          const displayName = selItem
            ? selItem.name + ": " + selItem.title
            : libraryName || null;
          return displayName ? (
            <div style={{
              padding: '8px 12px',
              marginBottom: 12,
              background: 'rgba(6, 190, 182, 0.1)',
              borderLeft: '3px solid rgb(6, 190, 182)',
              borderRadius: 4,
              fontSize: '0.875rem',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
            title={displayName}
            >
              <strong>Currently selected:</strong>{' '}
              {displayName}
            </div>
          ) : null;
        })()}
        <div
          id="libraries-container-selector"
          style={{ overflow: "auto", height: "500px" }}
        >
          <InfiniteScroller
            loadMore={() => {
              if (!loading && pageInfo.loadMore) this.loadLibraries();
            }}
            parentId="libraries-container-selector"
          >
            <Table responsive>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Title</th>
                  <th>Topics</th>
                </tr>
              </thead>
              <tbody>
                {libraries.map((item, index) => {
                  const isSelected =
                    item.name === libraryName ||
                    item.id === libraryId ||
                    (item.idFromPackage && item.idFromPackage === libraryId) ||
                    (item.originalIDFromPackage &&
                      item.originalIDFromPackage === libraryId);
                  return (
                    <tr
                      className="attribute-row-hover"
                      key={index}
                      style={{
                        cursor: "pointer",
                        ...(isSelected ? { background: "rgba(6, 190, 182, 0.2)" } : {}),
                      }}
                      onClick={() => {
                        if (this.props.completeLib) {
                          this.props.selectLibrary(item);
                        } else {
                          this.props.saveLibraryName(item.name, item.id);
                        }
                      }}
                    >
                      <td>{item.name}</td>
                      <td>{item.title}</td>
                      <td>
                        {item.topics
                          ?.map((t) => (topicsMap[t] ? topicsMap[t].title : ""))
                          .join(", ")}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
            {loading && (
              <div style={{ margin: "10px auto", width: 100 }}>
                <MPSBarLoader />
              </div>
            )}
          </InfiniteScroller>
        </div>
      </div>
    );
  }
}

export default connect((state) => {
  return {
    userRole: state.user.role,
    libraries: state.mpsPackage.selectedPackage
      ? state.mpsPackage.selectedPackage.libraries
      : [],
    topics: state.mpsPackage.selectedPackage
      ? state.mpsPackage.selectedPackage.libTopics
      : [],
  };
})(ContentLibrarySelector);
